export default __webpack_public_path__ + "static/media/voting.0f9b99c2.jpeg";